import { CustomRequest } from "vendor/infrastructure/custom_requests";
import { updateSending } from "vendor/application/disptach";
import { CustomRequestManager } from "vendor/infrastructure/custom_requests_manager";

export class UsersAPI {
  constructor(userID, token, props, body) {
    this.userID = userID;
    this.token = token;
    this.props = props;
    this.body = body;

    this.props.dispatch(updateSending(true));
  }

  async put_user() {
    const request = new CustomRequest(
      "PUT",
      `users/${this.props.id}`,
      JSON.stringify(this.body),
      this.token,
      this.props
    );
    const req = await request.action();
    this.props.dispatch(updateSending(false));
    return req;
  }

  async put_lang() {
    const request = new CustomRequest(
      "PUT",
      `users/${this.userID}`,
      JSON.stringify(this.body),
      this.token,
      this.props
    );
    const req = await request.action();
    this.props.dispatch(updateSending(false));
    return req;
  }

  async post_user() {
    const request = new CustomRequest(
      "POST",
      "users",
      JSON.stringify(this.body),
      this.token,
      this.props
    );
    const req = await request.action();
    this.props.dispatch(updateSending(false));
    return req;
  }

  async get_user_by_id() {
    let request = new CustomRequest(
      "GET",
      `users/${this.props.id}`,
      null,
      this.token,
      this.props
    );
    var req = await request.action();
    this.props.dispatch(updateSending(false));
    return req;
  }

  async get_user_info() {
    let request = new CustomRequest(
      "GET",
      `users/${this.userID}`,
      null,
      this.token,
      this.props
    );
    var req = await request.action();
    this.props.dispatch(updateSending(false));
    return req;
  }

  async get_account_by_id(id) {
    let request = new CustomRequest(
      "GET",
      `accounts/${id}`,
      null,
      this.token,
      this.props
    );
    var req = await request.action();
    this.props.dispatch(updateSending(false));
    return req;
  }

  async get_plans() {
    let request = new CustomRequest(
      "GET",
      "plans",
      null,
      this.token,
      this.props
    );
    var req = await request.action();
    this.props.dispatch(updateSending(false));
    return req;
  }

  async get_account_users(id) {
    let request = new CustomRequestManager(
      "GET",
      `accounts/${id}/users`,
      null,
      this.token,
      this.props
    );
    var req = await request.action();
    this.props.dispatch(updateSending(false));
    return req;
  }

  async get_webhook(id) {
    let request = new CustomRequest(
      "GET",
      `accounts/${id}/webhooks`,
      null,
      this.token,
      this.props
    );
    return await request.action();
  }

  async post_webhook(id) {
    let request = new CustomRequest(
      "POST",
      `accounts/${id}/webhooks`,
      JSON.stringify(this.body),
      this.token,
      this.props
    );
    return await request.action();
  }

  async get_countries() {
    const request = new CustomRequest(
      "GET",
      "countries",
      null,
      this.token,
      this.props
    );
    const req = await request.action();
    this.props.dispatch(updateSending(false));
    return req;
  }
}
